import service from './Setting'



// export const CheckValidAddr = (obj) => service.post(`/Code/CheckAddr`, obj);
export const GetInfoByAddressOrXY = (obj) => service.get('/Map8/GetInfoByAddressOrXY',{params:obj});

//取得指定縣市區域內據點資訊
export const GetPlaceInfoByCounty = (obj) => service.get('/Map8/GetPlaceInfoByCounty',{params:obj});

//取得預設距離內內據點資訊
export const GetRangePlaceInfo = (obj) => service.get('/Map8/GetRangePlaceInfo',{params:obj});

//地點輸入自動完成（至少兩個字）
export const GetPlaceAutocomplete = (obj) => service.get('/Map8/GetPlaceAutocomplete',{params:obj});

//以地點ID 取得詳細資訊
export const GetPlaceDetails = (obj) => service.get(`/Map8/GetPlaceDetails`,{params:obj});

//路徑規劃 （取得起訖距離和花費時間）
export const GetPlanRoute = (obj) => service.get(`/Map8/PlanRoute/`,{params:obj});


